import styled from 'styled-components'

const ImgContainer = styled('div')`
  position: relative;
  background: ${props => props.background || 'transparent'};
`

export default ImgContainer
